<div class="main-container">
  <div class="mb-2" style="position:relative;">
    <button style="padding: 0;border: none;background: white; color: black;" [ngbTooltip]="'Back'" aria-label="back" (click)="cancelRequest.emit()"><span class="fa fa-angle-left mr-2" style="cursor: pointer;font-size: 22px;font-weight: bold;"></span></button>
    <b class="nav-content-header">Request to Update Information</b>
  </div>
  <form [formGroup]="profileForm" (ngSubmit)="onSubmit(content)" class="profile-form">
    <div class="form-row">
      <div class="form-group col-md-6">
        <label class="bold-label" for="entity-name">Name</label>
        <input id="entity-name" type="text" formControlName="Name" class="form-control">
      </div>
      <div class="form-group col-md-6">
        <label class="bold-label" for="preferred-email">Preferred Email</label>
        <input type="email" id="preferred-email" formControlName="EmailAddress" class="form-control" [attr.aria-invalid]="profileForm.get('EmailAddress')?.invalid">
        @if (profileForm.get('EmailAddress')?.invalid) {
          <div class="invalid-feedback d-inline-block">Email is invalid.</div>
        }
      </div>
    </div>

    <div class="form-row">

      <div class="form-group col-md-6">
        <label class="bold-label" for="preferred-phone">Preferred Phone Number</label>
        <input id="preferred-phone" type="tel" formControlName="PhoneNumber" class="form-control">
      </div>
      <div class="form-group col-md-6">
        <label class="bold-label" for="fax-number">Fax Number</label>
        <input type="tel" id="fax-number" formControlName="Fax" class="form-control">
      </div>
    </div>

    <label for="mailing-address-info" class="bold-label">Mailing Address</label>
    <div class="form-check mb-2">
      <input id="no-mailing-checkbox" type="checkbox" formControlName="noMailingAddress" class="form-check-input">
      <label class="form-check-label" for="no-mailing-checkbox">No Mailing Address</label>
    </div>

    <div id="mailing-address-info" [ngClass]="{'d-none': profileForm.get('noMailingAddress')?.value}">
      <div class="form-group">
        <label class="bold-label" for="address-line-1">Address Line 1</label>
        <input id="address-line-1" type="text" formControlName="Address1" class="form-control">
      </div>
      <div class="form-group">
        <label class="bold-label" for="address-line-2">Address Line 2</label>
        <input id="address-line-2" type="text" formControlName="Address2" class="form-control">
      </div>
      <div class="form-group">
        <label class="bold-label" for="address-line-3">Address Line 3</label>
        <input id="address-line-3" type="text" formControlName="Address3" class="form-control">
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label class="bold-label" for="entity-city">City</label>
          <input id="entity-city" type="text" formControlName="City" class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="entity-province" class="bold-label">Province/State</label>
          <input id="entity-province" type="text" formControlName="Province" class="form-control">
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="entity-country" class="bold-label">Country</label>
          <input id="entity-country" type="text" formControlName="Country" class="form-control">
        </div>
        <div class="form-group col-md-6">
          <label for="entity-postal-code" class="bold-label">Postal Code</label>
          <input id="entity-postal-code" type="text" formControlName="Postal" class="form-control">
        </div>
      </div>
    </div>

    <button class="btn btn-sm btn-secondary mr-2 mb-2" (click)="fillTheForm($event)">Clear Changes</button>
    <button type="submit" [disabled]="isImpersonated" class="btn btn-sm btn-primary mb-2">Submit Update Request</button>
    <span style="color: red" class="ml-2">{{errorMessage}}</span>
  </form>

</div>
<ng-template #content let-modal>
  <nwm-advisor-contact formAction="MessageAdvisor" [alreadySubmitted]="true" (formCancelled)="modal.close()" />
</ng-template>
